import React from 'react';

import {
  useLoadCostModel,
  useLoadCampaignDetails,
} from 'scenes/Campaigns/GGCampaigns/data';
import { useEditCostModel } from 'scenes/Campaigns/GGCampaigns/data/mutations';

import { CostModelForm } from 'scenes/Campaigns/components/CostModel';

export const CostModelFormCreate = ({ campaignId, ...props }) => {
  const { data: campaignData } = useLoadCampaignDetails({
    id: campaignId,
  });
  return (
    <CostModelForm
      {...props}
      title={'Add Cost Model period'}
      subTitle={campaignData?.name}
    />
  );
};

export const CostModelFormEdit = ({
  onSubmit,
  campaignId,
  id,
  onClose,
  initialValues,
  ...props
}) => {
  const { data: campaignData } = useLoadCampaignDetails({
    id: campaignId,
  });
  const singleCostPeriod = initialValues?.type?.isSingleCostPeriod || false;
  return (
    <CostModelForm
      {...props}
      onClose={onClose}
      title={'Edit Cost Model period'}
      subTitle={campaignData?.name}
      initialValues={initialValues}
      onSubmit={onSubmit}
      canAddPeriod={!singleCostPeriod}
      canRemovePeriod={true}
      entityId={id}
      isEdit
    />
  );
};

export const CostModelFormEditExisting = ({
  onSubmit,
  campaignId,
  id,
  onClose,
  ...props
}) => {
  const [editCostModel, { isLoading: isUpdating }] = useEditCostModel();
  const { data: initialValues, isLoading } = useLoadCostModel({
    id,
    campaignId,
  });

  const handleSubmit = async (values) => {
    await editCostModel({ campaignId, id, ...values });
    onSubmit({ campaignId, id, ...values });
  };

  const singleCostPeriod = initialValues?.type?.isSingleCostPeriod || false;
  return (
    <CostModelFormEdit
      {...props}
      id={id}
      onClose={onClose}
      campaignId={campaignId}
      title={'Edit Cost Model period'}
      initialValues={initialValues}
      active={!!initialValues}
      loading={isLoading || isUpdating}
      onSubmit={handleSubmit}
      canAddPeriod={!singleCostPeriod}
      canRemovePeriod={true}
    />
  );
};
